import { useState } from "react";

/**
 * Lightweight modal wrapper around a <video> element. Closes on backdrop
 * click or the × button. Autoplay is enabled (muted) so the admin can
 * preview-scrub quickly during moderation review.
 *
 * Decode failures are surfaced rather than left as a silent black frame.
 * Without the onError branch a moderator just sees nothing happen and can't
 * tell an unplayable file from a slow one.
 *
 * The case this actually catches: ~45% of the library is HEVC/H.265 (iPhone
 * default — the upload path never transcoded). Chrome >=107 on macOS/Windows,
 * Safari, Edge and Android all decode it, so most moderators never hit this;
 * Firefox and machines without HEVC hardware are the gap.
 */
const ProductVideoPlayerModal = ({ video, onClose }) => {
    const [failed, setFailed] = useState(false);

    if (!video) return null;
    return (
        <div className="product-video-player-modal" onClick={onClose}>
            <button type="button" className="close" onClick={onClose}>
                ×
            </button>
            {failed ? (
                <div className="playback-error" onClick={(e) => e.stopPropagation()}>
                    <p>تعذّر تشغيل الفيديو في هذا المتصفح.</p>
                    <p className="hint">
                        قد يكون الترميز غير مدعوم (HEVC/H.265). جرّب متصفح Safari، أو حمّل الملف
                        لمراجعته.
                    </p>
                    <a href={video.videoUrl} target="_blank" rel="noreferrer">
                        فتح الملف مباشرة
                    </a>
                </div>
            ) : (
                <video
                    src={video.videoUrl}
                    poster={video.thumbnailUrl || undefined}
                    controls
                    autoPlay
                    muted
                    playsInline
                    onError={() => setFailed(true)}
                    onClick={(e) => e.stopPropagation()}
                />
            )}
        </div>
    );
};

export default ProductVideoPlayerModal;
